import CompLayout from "@/pcomponents/comp/layout/layout";
import SupplyMultyAddArea from "@/pages/comp/supply/supply/common/muly_add_list";

function SupplyMultyAdd() {

  return (
    <CompLayout>
      <SupplyMultyAddArea></SupplyMultyAddArea>
    </CompLayout>
  );
}

export default SupplyMultyAdd;